import styled from 'styled-components'
import { Gray } from 'assets/styled-component/variables'

export const ListAddress = styled.p`
  color: ${Gray[500]};
  margin-bottom: '2rem';
`
